import { Compartment } from "../requests/useCreateStagedOrder";

export const sum = (values: number[]) =>
  values.reduce((s, v) => s = +s + +v, 0);

export const sumWeights = (compartments: Compartment[]) =>
  sum(compartments.map(c => c.weight).filter(w => w));

export const arraysEqual = (a: string[], b: string[]) =>
  (a.length === b.length) && a.every((element) => b.includes(element));

export const isProdEnvironment = () =>
  process.env.REACT_APP_ENVIRONMENT === "prod";

export const isPwaMode = () => {
  // iOS progressive web app detection
  const navigator: any = window.navigator;
  if (navigator.standalone)
    return true;

  // default progressive web app detection
  return ["fullscreen", "standalone", "minimal-ui"].some(
    (displayMode) => window.matchMedia('(display-mode: ' + displayMode + ')').matches
  );
}

const ALIAS_DICTIONARY: Record<string, string> = {
  "st.": "Saint", "st": "Saint",
  "mt.": "Mount", "mt": "Mount",
  "ft.": "Fort", "ft": "Fort",

  "n.": "North", "n": "North",
  "s.": "South", "s": "South",
  "w.": "West", "w": "West",
  "e.": "East", "e": "East",
  "n.w.": "Northwest", "nw": "Northwest",
  "n.e.": "Northeast", "ne": "Northeast",
  "s.w.": "Southwest", "sw": "Southwest",
  "s.e.": "Southeast", "se": "Southeast",
}

export const getFullNameFromAlias = (a: string) => {
  let words: string[] = a.split(" ");
  for (let i = 0; i < words.length; i++) {
    if (ALIAS_DICTIONARY[words[i].toLowerCase()]) {
      words[i] = ALIAS_DICTIONARY[words[i].toLowerCase()];
    }
  }
  return words.join(" ");
}

function createHashForString(s: string) {
  var hash = 0, i, chr;
  for (i = 0; i < s.length; i++) {
    chr = s.charCodeAt(i);
    hash = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

export const createHashForStrings = (strings: Array<string>) => 
  strings.reduce((sum, s) => sum + createHashForString(s), 0);

export const capitalizeFirstLetter = (s: string) =>
  s ? s[0].toUpperCase() + s.slice(1) : ""

// Sorts objects in a human-friendly way using case-insensitive natural order sorting.
// Examples:
// - Bay 1, Bay 2, Bay 10 will be sorted as: Bay 1, Bay 2, Bay 10 (not Bay 1, Bay 10, Bay 2).
// - Apple, Banana, apple, banana will be sorted as: Apple, apple, Banana, banana 
//   (instead of Apple, Banana, apple, banana).
export const humanReadableSort = <T>(items: T[], field: keyof T) =>
  [...items].sort((a, b) =>
    String(a[field] ?? '').localeCompare(String(b[field] ?? ''), undefined, { numeric: true, sensitivity: 'base' })
  );

export const dateSort = <T>(items: T[], field: keyof T) =>
  [...items].sort((a, b) =>
    new Date(String(b[field])).getTime() - new Date(String(a[field])).getTime());

export const getDisabledStyle = (isDisabled: boolean): React.CSSProperties =>
  isDisabled ? { pointerEvents: "none", opacity: 0.6 } : {};